/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AuditReportsAodRule } from "./AuditReportsAodRule";
import type { AuditReportsAodRunStatusData } from "./AuditReportsAodRunStatusData";
import type { AuditReportsPublicJobDto } from "./AuditReportsPublicJobDto";
import type { AuditReportsPublicJobWithResultDto } from "./AuditReportsPublicJobWithResultDto";

export const AuditReportsAodRunTypeEnum = {
    EOW: "EOW",
    ORDER_END: "ORDER_END",
    MANUAL: "MANUAL"
} as const;

export type AuditReportsAodRunTypeEnumKey = (typeof AuditReportsAodRunTypeEnum)[keyof typeof AuditReportsAodRunTypeEnum];

export const AuditReportsAodRunStatusEnum = {
    WAITING: "WAITING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED_WITH_EXPORT: "COMPLETED_WITH_EXPORT",
    COMPLETED_WITHOUT_EXPORT: "COMPLETED_WITHOUT_EXPORT",
    WAITING_FOR_REPROCESS: "WAITING_FOR_REPROCESS",
    FAILED: "FAILED"
} as const;

export type AuditReportsAodRunStatusEnumKey = (typeof AuditReportsAodRunStatusEnum)[keyof typeof AuditReportsAodRunStatusEnum];

export const AuditReportsAodRunUserStatusEnum = {
    ACCEPTED: "ACCEPTED",
    REFRESHED: "REFRESHED",
    REPROCESSED: "REPROCESSED"
} as const;

export type AuditReportsAodRunUserStatusEnumKey = (typeof AuditReportsAodRunUserStatusEnum)[keyof typeof AuditReportsAodRunUserStatusEnum];

export type AuditReportsAodRun = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type object
    */
    rule: AuditReportsAodRule;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined, date-time
    */
    scheduledDatetime?: string;
    /**
     * @deprecated
     * @type string | undefined, date-time
    */
    datetime?: string;
    /**
     * @type string
    */
    type: AuditReportsAodRunTypeEnumKey;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string
    */
    jobId: string;
    /**
     * @type string | undefined
    */
    reprocessJobId?: string;
    /**
     * @type string
    */
    status: AuditReportsAodRunStatusEnumKey;
    /**
     * @type object | undefined
    */
    statusData?: AuditReportsAodRunStatusData;
    /**
     * @type string
    */
    userStatus: AuditReportsAodRunUserStatusEnumKey;
    /**
     * @deprecated
     * @type object
    */
    userStatusData: {
        /**
         * @type string | undefined, date-time
        */
        updatedAt?: string;
        /**
         * @type string | undefined
        */
        userId?: string;
    } | null;
    /**
     * @type string | undefined
    */
    reportId?: string;
    /**
     * @type object | undefined
    */
    overrideReportConfig?: object;
    /**
     * @type object | undefined
    */
    overrideExportConditions?: object;
    /**
     * @type string
    */
    order: string;
    /**
     * @type string | undefined
    */
    interval?: string;
    /**
     * @type string | undefined
    */
    snapshotHash?: string;
    /**
     * @description Number of times this run was executed (processed by ProcessAodRunJob).
     * @type number
    */
    executionCount: number;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type boolean
    */
    canRestart: boolean;
    /**
     * @type boolean
    */
    canRefresh: boolean;
    /**
     * @type boolean
    */
    canAccept: boolean;
    /**
     * @type boolean
    */
    canReprocess: boolean;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @type boolean
    */
    isCompleted: boolean;
    /**
     * @type boolean
    */
    isFailed: boolean;
    /**
     * @type boolean
    */
    isRefreshing: boolean;
    /**
     * @type boolean
    */
    isAccepting: boolean;
    /**
     * @type boolean
    */
    isReprocessStarted: boolean;
    /**
     * @type boolean
    */
    isReprocessCompleted: boolean;
    /**
     * @type boolean
    */
    isReprocessFailed: boolean;
    /**
     * @type number | undefined
    */
    efficiency?: number;
    /**
     * @type object
    */
    processJobStatus: AuditReportsPublicJobDto | null;
    /**
     * @type object
    */
    reprocessJobStatus: AuditReportsPublicJobWithResultDto | null;
};